import { Button } from "antd";
import { PlusOutlined, MinusOutlined, DeleteOutlined } from '@ant-design/icons';
import { useClient } from "../../../context/ClientContext";
import ImagenNoDisp from "../../../assets/imagen-no-disponible.jpeg";

export const CardItemDesktop = ({ producto, onUpdate, onDelete, promoLabel }) => {
  const { theme } = useClient();
  const primary = theme.primaryColor || '#111827';
  const precioFinal = producto?.promo?.precio_final ?? null;
  const precioUnit = precioFinal ?? producto?.precio_unit ?? 0;
  const subtotal = precioUnit * (producto?.cantidad || 0);

  return (
    <div style={{
      display: "flex", gap: 16, alignItems: "center", padding: "16px 0",
    }}>
      <div style={{
        width: 80, height: 80, borderRadius: 10, overflow: "hidden", flexShrink: 0,
        background: "#f5f5f7", display: "flex", alignItems: "center", justifyContent: "center",
        position: "relative",
      }}>
        <img
          src={producto?.imagen || ImagenNoDisp}
          alt={producto?.producto}
          style={{ width: "100%", height: "100%", objectFit: "contain", padding: 8 }}
          onError={e => { e.target.src = ImagenNoDisp; }}
        />
        {promoLabel && (
          <div style={{
            position: "absolute", top: 4, left: 4,
            background: "#e53e3e", color: "#fff",
            fontSize: 9, fontWeight: 700, padding: "2px 5px",
            borderRadius: 4, lineHeight: 1.2,
          }}>
            {promoLabel}
          </div>
        )}
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: "#111827", marginBottom: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {producto?.producto}
        </div>
        {producto?.codigo && (
          <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 8 }}>CÓD. {producto.codigo}</div>
        )}
        <div style={{ display: "flex", alignItems: "center", gap: 2, border: "1.5px solid #e5e7eb", borderRadius: 8, width: "fit-content" }}>
          <button
            onClick={() => producto.cantidad > 1 && onUpdate(-1)}
            disabled={producto.cantidad <= 1}
            style={{
              width: 32, height: 32, border: "none", background: "transparent",
              cursor: producto.cantidad <= 1 ? "not-allowed" : "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              color: producto.cantidad <= 1 ? "#d1d5db" : "#374151", fontSize: 14,
            }}
          >
            <MinusOutlined />
          </button>
          <span style={{ width: 32, textAlign: "center", fontSize: 14, fontWeight: 600, color: "#111827" }}>
            {producto.cantidad}
          </span>
          <button
            onClick={() => onUpdate(1)}
            style={{
              width: 32, height: 32, border: "none", background: "transparent",
              cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
              color: "#374151", fontSize: 14,
            }}
          >
            <PlusOutlined />
          </button>
        </div>
      </div>

      <div style={{ textAlign: "right", flexShrink: 0 }}>
        {precioFinal != null ? (
          <div style={{ fontSize: 12, marginBottom: 2 }}>
            <span style={{ color: "#9ca3af", textDecoration: "line-through", marginRight: 5 }}>
              ${producto?.precio_unit?.toFixed(2)}
            </span>
            <span style={{ color: "#e53e3e", fontWeight: 600 }}>
              ${precioFinal.toFixed(2)} c/u
            </span>
          </div>
        ) : (
          <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 2 }}>
            ${producto?.precio_unit?.toFixed(2)} c/u
          </div>
        )}
        <div style={{ fontSize: 17, fontWeight: 700, color: precioFinal != null ? "#e53e3e" : primary }}>
          ${subtotal.toFixed(2)}
        </div>
      </div>

      <button
        onClick={onDelete}
        style={{
          width: 32, height: 32, border: "1px solid #fca5a5", borderRadius: "50%",
          background: "#fff", cursor: "pointer", flexShrink: 0,
          display: "flex", alignItems: "center", justifyContent: "center",
          color: "#ef4444", fontSize: 13, transition: "border-color 0.15s",
        }}
        onMouseEnter={e => e.currentTarget.style.borderColor = '#ef4444'}
        onMouseLeave={e => e.currentTarget.style.borderColor = '#fca5a5'}
      >
        <DeleteOutlined />
      </button>
    </div>
  );
}
